import React from 'react';
import LeftNav from '../common/leftnav/leftnav';
import HeaderTop from '../common/headerTop/headerTop';
import Axios from 'axios';
import { API_HOST, axiosRequestWithAuth, axiosInstance, SLACK_OAUTH_URL, SLACK_APP_STATE, SLACK_CLIENT_ID, SLACK_BOT_SCOPES, SLACK_USER_SCOPES, SLACK_REDIRECT_URI } from './../../constants/server.constant';
import CommonMessage from './../common/commonMessage';
import { Redirect } from 'react-router-dom';
import { ResourceService } from './../../services/resource.service';
import NotificationSlider from '../common/topRightHeader/notificationSlider';
import SlackPopupWindow from './slackPopupWindow';
import { SlackService } from '../../services/slack.service';
import { AlarmService } from '../../services/alarm.service';
import $ from 'jquery';
import ReactTooltip from 'react-tooltip';
import { userService } from '../../services/user.service';
import { toQuery } from '../../utility/utility';
import ScrollArea from 'react-scrollbar';
import { getMessage } from '../../constants/messagesMapper';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Validate from '../common/validate';
import { ApplicationService } from '../../services/applicationcredentialsservice';
import yaml from 'js-yaml';
import { withStyles } from "@material-ui/styles";
const styles = () => ({
    overrideMe: {
        width: "400px",
        "word-break": "break-all",
        "overflow-wrap": "break-word",
        display: "block"
    }
});
class SettingsMain extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            is2fapopup: false,
            userId: localStorage.getItem("userId"),
            isAction: false,
            totalUsers: 0,
            total2faUsers: 0,
            adminStatus: "",
            message: "",
            isUserSubscribed: false,
            isRedirectToCCPage: false,
            isActive: 'preferences',
            emailToggle: false,
            isEventAlarmEnabled: false,
            eventAlarm: null,
            users: [],
            selectedEmailList: [],
            sliderEmailList: [],
            sliderEmailSelectAll: false,
            sliderEmailSortOrder: false,
            slackWebhooks: [],
            isUnlinkSlackPopupActive: false,
            unlinkSlackChannelIdx: -1,
            showAddRecipients: false,
            addRecipientsSliderSearchText: "",
            addRecipientsSliderMaxHeight: window.visualViewport.height - 411,
            scrollBarOpacity: 0,
            defaultEmailSelection: localStorage.getItem("defaultEmailSelectionAlertPolicy")?.length > 0,
            defaultEmailAlertList: [],
            openAppCred: false,
            deleteAppCred: false,
            credName: "",
            credDesc: "",
            expirationDate: "",
            expirationTime: "",
            credNameError: "",
            credDescError: "",
            credDateError: "",
            credTimeError: "",
            credData: [],
            showSuccessPopup: false,
            currentId: "",
            currentSecret: "",
            currentEmail: "",
            currentDeleteUser: "",
            dataCached: false,
            isCopied: false,
            count: 50,
            indexCount: 0,
            credDataPaged: []
        };
        this.credNameRef = React.createRef();
        this.credDescRef = React.createRef();
        this.credDateRef = React.createRef();
        this.credTimeRef = React.createRef();
        this.enable2fapopup = this.enable2fapopup.bind(this);
        this.getAdmin2FAInfo = this.getAdmin2FAInfo.bind(this);
        this.enterPopUp = this.enterPopUp.bind(this);
        this.escfunction = this.escfunction.bind(this);
        this.scrollRef = React.createRef();
        this.addRecipientsRef = React.createRef();
        this.addRecipientsSliderSearchFocus = React.createRef();
    }
    enterPopUp = (event) => {
        var code = event.keyCode || event.which;
        if(code === 13) {
            this.enable2fa();
        }
    };

    escfunction(event) {
        if(event.keyCode === 27) {
            this.setState({
                is2fapopup: false,
                deleteAppCred: false,
                openAppCred: false,
                showSuccessPopup: false
            });
        }
        $("body").removeClass("popup_no_scroll");
    }

    handleKeypress(event) {
        let code = event.keyCode ? event.keyCode : event.which;
        if(code === 13 || (code === 32 && !document.activeElement.tagName.includes("input"))) {
            document.activeElement.click();
        }
    }

    addRecipientsFocusHandler = (event) => {
        if(!document.getElementById("addRecipientsSlider").contains(event.target) && this.state.showAddRecipients) {
            // clicked outside the add-recipients slider 
            this.toggleAddRecipientsSlider(event);
        }
    };
    componentWillUnmount() {
        $("body").removeClass("popup_no_scroll");
        document.removeEventListener("keyup", this.escfunction, false);
        window.clearTimeout(sessionStorage.getWebhookTimeout);
        window.clearTimeout(sessionStorage.enableFocus);
        window.clearTimeout(sessionStorage.addRecipientsSliderSearchFocusTimeout);
        window.removeEventListener("click", this.addRecipientsFocusHandler, true);
        window.removeEventListener("resize", this.refreshScrollBar, true);
        window.removeEventListener("keypress", this.handleKeypress, true);
    }
    componentDidMount() {
        if(!sessionStorage.settingsLoaded) {
            asyncCall().then(() => this.setState({ loading: false }));
        }
        document.addEventListener("keyup", this.escfunction, false);
        this.setState({
            isAction: true
        });
        window.addEventListener("click", this.addRecipientsFocusHandler, true);
        window.addEventListener("resize", this.refreshScrollBar, true);
        window.addEventListener("keypress", this.handleKeypress, true);
        this.checkForSubscription();
        this.getAdmin2FAInfo();
        this.getEventBasedAlarms();
        this.getSlackWebhooks();
        this.getUsersByProject();
        this.addRecipientsRef.current.focus();
    }
    checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while getting user subscription details"

                });
                return;
            }
            if(resp.error) {
                this.setState({
                    isAction: false,
                    isUserSubscribed: true
                });
            }
            else {
                this.setState({
                    isUserSubscribed: false
                });
                this.getAdmin2FAInfo();

            }

        });
    };

    getAdmin2FAInfo = () => {
        axiosInstance.get(API_HOST + "/user/getadmin2fainfo/" + this.state.userId, axiosRequestWithAuth).then(resp => {
            this.setState({
                isAction: false
            });
            let admin = resp.data.body;
            this.setState({
                totalUsers: admin.totalUsers,
                total2faUsers: admin.total2faUsers,
                adminStatus: admin.adminStatus
            });

        }).catch(error => {
            this.setState({
                isAction: false
            });
        });
    };

    getApplicationCredentials = () => {
        if(this.state.dataCached) {
            return;
        }
        this.setState({
            isAction: true
        });
        ApplicationService.listApplicationCredential().then(resp => {
            if(resp === null) {
                this.setState({
                    message: "Error while listing user credentials, Please try again after some time",
                    msgType: "error",
                    isAction: false
                });
                return;
            }
            resp = resp.data;
            if(resp === "KEYSTONE_NAME_ERROR") {
                this.setState({
                    message: "",
                    msgType: "",
                    isAction: false
                });
                return;
            }
            if(resp === "USER_NOT_FOUND") {
                this.setState({
                    message: "Error while listing user credentials, Please try again after some time",
                    msgType: "error",
                    isAction: false
                });
                return;
            }
            let data = [];
            for(let i = 0; i < resp.length; i++) {

                let obj = {
                    id: resp[i].id,
                    name: resp[i].name,
                    userId: resp[i].user_id,
                    expires: resp[i].expires_at != "null" ? this.getDate(resp[i].expires_at) : "Never",
                    description: resp[i].description != null && resp[i].description.length > 0 ? resp[i].description : "N/A"

                };
                data.push(obj);
            }
            data.sort(function (a, b) {
                if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
            let credDataPaged = [...data];
            if(data.length > this.state.count) credDataPaged = credDataPaged.slice(0, this.state.count);
            this.setState({
                credData: data,
                credDataPaged: credDataPaged,
                dataCached: true,
                isAction: false,
                indexCount: 0
            });
        })
            .catch(error => {
                this.setState({
                    message: "Error while listing user credentials, Please try again after some time",
                    msgType: "error",
                    isAction: false
                });
            });
    };

    getDate = (date) => {
        let UTCtime = date + "Z";
        let d = new Date(UTCtime);
        let expireddate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + d.toLocaleString([], {
            hour: '2-digit',
            minute: '2-digit'
        });
        return expireddate;
    };

    getEventBasedAlarms = () => {
        this.setState({
            isAction: true,
        });
        AlarmService.fetchAlarmsByType(this.state.userId, "event").then(resp => {
            let data = resp.data;
            if(data.ok) {
                if(data.alarms?.length > 0) {
                    this.setState({
                        isEventAlarmEnabled: true,
                        eventAlarm: data.alarms[0]
                    }, this.refreshChannelSelections);
                }
            }
            this.setState({
                isAction: false,
            });
        }).catch(error => {
            if(error?.response?.data) {
                let data = error.response.data;
                console.log(data.error);
                this.setState({
                    message: data.details,
                    msgType: "error",
                    isAction: false,
                });
            } else {
                console.log(error);
                this.setState({
                    message: "Error occurred while fetching event alarms. Please try again.",
                    msgType: "error",
                    isAction: false,
                });
            }
        });
    };

    refreshChannelSelections = () => {
        this.setState({
            isAction: true
        });
        if(this.state.selectedEmailList.length > 0) {
            let eventEmailList = this.state?.eventAlarm?.emailList ? Array(...this.state.eventAlarm.emailList) : [];
            let emailList = new Array(...this.state.selectedEmailList);
            let flag = false;
            let activeUsers = Array(...this.state.users).filter((user) => user.isActive);
            activeUsers.forEach((user, idx) => {
                if(eventEmailList.find(email => email === user.email) !== undefined) {
                    emailList[idx] = true;
                    flag = true;
                }
                else emailList[idx] = false;
            });
            if(!flag && !this.state.isEventAlarmEnabled) {
                let defaultEmailList = localStorage.getItem("defaultEmailSelectionAlertPolicy") ? Array(...localStorage.getItem("defaultEmailSelectionAlertPolicy").split(",")) : [];
                if(this.state.defaultEmailSelection && defaultEmailList.length > 0) {
                    emailList = emailList.map((email, idx) => defaultEmailList.find(val => val === String(this.state.users[idx].id)) !== undefined);
                } else {
                    emailList[0] = true;
                }
            }
            this.setState(prevState => {
                return {
                    ...prevState,
                    selectedEmailList: emailList
                };
            });
        }
        if(this.state.slackWebhooks.length > 0) {
            let eventWebhooks = this.state.eventAlarm?.slackWebhooks ? this.state.eventAlarm.slackWebhooks : [];
            let slackWebhooks = new Array(...this.state.slackWebhooks);
            if(eventWebhooks?.length > 0) {
                slackWebhooks.forEach(webhook => {
                    if(eventWebhooks.find((val) => val.id === webhook.data.id) !== undefined) {
                        webhook.isSelected = true;
                    }
                });
            }
            this.setState({
                slackWebhooks: slackWebhooks,
            });
        }
        this.setState({
            isAction: false,
        });
    };

    getSlackWebhooks = (count) => {
        this.setState({
            isAction: true,
        });
        SlackService.fetchWebhooks(this.state.userId).then(resp => {
            let data = resp?.data;
            if(data.ok) {
                let slackWebhooks = data.webhooks ? Array(...data.webhooks).map(webhook => {
                    let webhookObj = {
                        data: webhook,
                        isSelected: false
                    };
                    return webhookObj;
                }) : [];
                slackWebhooks = slackWebhooks.sort((s1, s2) => {
                    if(s1.data.channelName < s2.data.channelName) return -1;
                    if(s1.data.channelName > s2.data.channelName) return 1;
                    return 0;
                });
                let eventWebhooks = this.state?.eventAlarm?.slackWebhooks ? this.state.eventAlarm.slackWebhooks : [];
                if(eventWebhooks?.length > 0) {
                    slackWebhooks.forEach(webhook => {
                        if(eventWebhooks.find((val) => val.id === webhook.data.id) !== undefined) {
                            webhook.isSelected = true;
                        }
                    });
                }
                let flag = count ? count < slackWebhooks.length : true;
                let message = count ? flag ? "Successfully integrated slack channel." : "Error while integrating slack channel!" : "";
                let msgType = flag ? "success" : "error";
                this.setState({
                    slackWebhooks: slackWebhooks,
                    isAction: false,
                    message: message,
                    msgType: msgType
                });
            } else {
                console.log(data.error);
                this.setState({
                    message: data.message,
                    msgType: "error",
                    isAction: false
                });
            }
        }).catch(error => {
            if(error?.response?.data) {
                let data = error.response.data;
                console.log(data.error);
                this.setState({
                    message: data.details,
                    msgType: "error",
                    isAction: false,
                });
            } else {
                console.log(error);
                this.setState({
                    message: "Error occurred while fetching webhooks. Please try again.",
                    msgType: "error",
                    isAction: false,
                });
            }
        });

    };

    getUsersByProject = () => {
        this.setState({
            isAction: true,
        });
        userService.getUsersByProject().then(resp => {
            let data = resp.data;
            if(data?.ok) {
                let eventEmailList = this.state?.eventAlarm?.emailList ? Array(...this.state.eventAlarm.emailList) : [];
                let emailList = [];
                let flag = false;
                let activeUsers = Array(...data.users).filter((user) => user.isActive);
                activeUsers.forEach(user => {
                    if(eventEmailList.find(email => email === user.email) !== undefined) {
                        emailList.push(true);
                        flag = true;
                    }
                    else emailList.push(false);
                });
                let defaultEmailList = localStorage.getItem("defaultEmailSelectionAlertPolicy") ? Array(...localStorage.getItem("defaultEmailSelectionAlertPolicy").split(",")) : [];
                if(!flag && !this.state.isEventAlarmEnabled) {
                    if(defaultEmailList.length > 0) {
                        emailList = emailList.map((email, idx) => typeof defaultEmailList.find(val => val === String(activeUsers[idx].id)) !== 'undefined');
                    } else {
                        emailList = emailList.map((email, idx) => localStorage.getItem("userId") === String(activeUsers[idx].id));
                    }
                }
                this.refreshScrollBar();
                this.setState(prevState => {
                    return {
                        ...prevState,
                        users: activeUsers,
                        selectedEmailList: emailList,
                        defaultEmailAlertList: defaultEmailList
                    };
                });
            } else {
                console.log(data.error);
                this.setState({
                    message: data.message,
                    msgType: "error"
                });
            }
            this.setState({
                isAction: false,
            });
        }).catch(error => {
            if(error?.response?.data) {
                let data = error.response.data;
                console.log(data.error);
                this.setState({
                    message: data.details,
                    msgType: "error",
                    isAction: false,
                });
            } else {
                console.log(error);
                this.setState({
                    message: "Error occurred while fetching project users. Please try again.",
                    msgType: "error",
                    isAction: false,
                });
            }
        });
    };

    enable2fapopup = () => {
        if(this.state.isUserSubscribed) {
            this.setState({
                isRedirectToCCPage: true
            });
        }
        else {
            this.setState({
                is2fapopup: true
            });
            sessionStorage.enableFocus = setTimeout(() => {
                document.getElementById("enablefocus").focus();
            }, 100);
        }


    };

    enable2fa = () => {
        this.setState({
            isAction: true,
            is2fapopup: false
        });
        let type = "";
        if(this.state.adminStatus === "ENABLED") {
            type = "DISABLE";
        }
        else {
            type = "ENABLE";
        }
        axiosInstance.post(API_HOST + "/user/authunticate2fa/" + type + "/" + this.state.userId, null, axiosRequestWithAuth).then(resp => {
            this.setState({
                isAction: false
            });
            this.getAdmin2FAInfo();
            resp = resp.data.body;
            if(resp === "NO_USERS_FOUND") {
                this.setState({
                    message: "No users found, you have not added any users to your account yet.",
                    msgType: "error"
                });
            }
            else if(resp === "AUTH_ENABLED") {
                this.setState({
                    message: "2FA has been enabled for all users",
                    msgType: ""
                });

            } else if(resp === "AUTH_DISABLED") {
                this.setState({
                    message: "2FA has been disabled for all users",
                    msgType: ""
                });
            } else if(resp === "ACCESS_DENIED") {
                this.setState({
                    message: "Access Denied",
                    msgType: "error"
                });
            }

        }).catch(error => {
            this.setState({
                isAction: false
            });
            this.setState({
                message: "Error while trying",
                msgType: "error"
            });
        });

    };

    tabClickHandler = (param) => {
        this.setState({
            isActive: param
        });
        if(param === "app_cred")
            this.getApplicationCredentials();

    };

    toggleEmailSelect = (event) => {
        if(event.target.id === 'togBtn') {
            this.setState((state) => {
                return { ...state, emailToggle: !state.emailToggle };
            });
        }
    };

    isDefaultEmailSelection = (defaultEmailAlertList, selectedEmailList) => {
        if(defaultEmailAlertList.length !== selectedEmailList.length) return false;
        return selectedEmailList.filter((data) => typeof defaultEmailAlertList.find(val => { return String(val) === String(this.state.users[data.idx].id); }) !== 'undefined').length === defaultEmailAlertList.length;
    };

    toggleAddRecipientsSlider = (event) => {
        this.setState((prevState) => {
            let sliderEmailList = new Array(...prevState.selectedEmailList);
            sliderEmailList = sliderEmailList.map((isSelected, idx) => {
                let data = {
                    "idx": idx,
                    "isSelected": isSelected,
                    "email": this.state.users[idx].email
                };
                return data;
            });
            return {
                ...prevState,
                sliderEmailList: sliderEmailList,
                showAddRecipients: !prevState.showAddRecipients,
                sliderEmailSelectAll: prevState.selectedEmailList.filter(isSelected => isSelected).length !== 0,
                addRecipientsSliderSearchText: '',
                defaultEmailSelection: this.isDefaultEmailSelection(prevState.defaultEmailAlertList, sliderEmailList.filter(data => data.isSelected))
            };
        }, this.toggleAddRecipientsSliderPost());
    };

    toggleAddRecipientsSliderPost = () => {
        if(!this.state.showAddRecipients) {
            $("body").addClass("popup_no_scroll");
            sessionStorage.addRecipientsSliderSearchFocusTimeout = window.setTimeout(() => this.addRecipientsSliderSearchFocus.current.focus(), 500);
        } else {
            $("body").removeClass("popup_no_scroll");
            this.addRecipientsRef.current.focus();
        }
    };

    userEmailSelectHandler = (event, idx) => {
        if(!(event.target.type === "checkbox")) {
            let emailList = this.state.sliderEmailList;
            emailList[idx].isSelected = !emailList[idx].isSelected;
            this.setState(prevState => {
                return {
                    ...prevState,
                    sliderEmailList: emailList,
                    sliderEmailSelectAll: emailList.filter(data => data.email.startsWith(this.state.addRecipientsSliderSearchText) && data.isSelected).length !== 0,
                    defaultEmailSelection: this.isDefaultEmailSelection(prevState.defaultEmailAlertList, emailList.filter(data => data.isSelected))
                };
            });
        }
    };

    emailButtonCloseHandler = (event, idx) => {
        let emailList = this.state.selectedEmailList;
        emailList[idx] = !emailList[idx];
        this.setState({
            selectedEmailList: emailList
        });
    };

    sliderEmailMultiSelectHandler = (event) => {
        let emailList = this.state.addRecipientsSliderSearchText ? this.state.sliderEmailList.filter(data => data.email.startsWith(this.state.addRecipientsSliderSearchText)) : this.state.sliderEmailList;
        let multiSelectSliderEmailList = this.state.sliderEmailList;
        let flag = false;
        if(emailList.filter(data => data.isSelected).length !== emailList.length) {
            multiSelectSliderEmailList = multiSelectSliderEmailList.map((data, i) => {
                if(data.email.startsWith(this.state.addRecipientsSliderSearchText)) {
                    data.isSelected = true;
                }
                return data;
            });
            flag = true;
        } else {
            multiSelectSliderEmailList = multiSelectSliderEmailList.map((data, i) => {
                if(data.email.startsWith(this.state.addRecipientsSliderSearchText)) {
                    data.isSelected = false;
                }
                return data;
            });
        }

        this.setState(prevState => {
            return {
                ...prevState,
                sliderEmailList: multiSelectSliderEmailList,
                sliderEmailSelectAll: flag,
                defaultEmailSelection: this.isDefaultEmailSelection(prevState.defaultEmailAlertList, multiSelectSliderEmailList.filter(data => data.isSelected))
            };
        });
    };

    isPartiallySelected = () => {
        let sliderEmailSearchList = this.state.sliderEmailList ? this.state.sliderEmailList.filter(data => data.email.startsWith(this.state.addRecipientsSliderSearchText)) : this.state.sliderEmailList;
        let count = sliderEmailSearchList.filter((data) => data.isSelected).length;
        if(count === sliderEmailSearchList.length || count === 0) return false;
        return true;
    };

    addRecipientsSliderSearchHandler = (event) => {
        this.setState(prevState => {
            let text = document.getElementById('addRecipientsSliderSearch').value;
            return {
                addRecipientsSliderSearchText: text,
                sliderEmailSelectAll: prevState.sliderEmailList.filter(data => data.email.startsWith(text) && data.isSelected).length !== 0
            };
        });
    };

    clearAddRecipientsSearch = (event) => {
        this.setState(prevState => {
            return {
                ...prevState,
                addRecipientsSliderSearchText: "",
                sliderEmailSelectAll: prevState.sliderEmailList.filter(data => data.isSelected).length !== 0
            };
        });
    };

    addRecipientsSubmitHandler = (event) => {
        let sliderEmailList = this.state.sliderEmailList.sort((d1, d2) => {
            if(d1.idx < d2.idx) return -1;
            if(d1.idx > d2.idx) return 1;
            return 0;
        }).map(data => data.isSelected);
        if(this.state.defaultEmailSelection) {
            let emailList = this.state.users.filter((user, idx) => sliderEmailList[idx]).map(user => user.id);
            localStorage.setItem("defaultEmailSelectionAlertPolicy", emailList);
            this.setState({
                defaultEmailAlertList: emailList,
            });
        } else {
            if(this.isDefaultEmailSelection(this.state.defaultEmailAlertList, this.state.sliderEmailList.filter(data => data.isSelected)) && !this.state.defaultEmailSelection) {
                localStorage.removeItem("defaultEmailSelectionAlertPolicy");
                this.setState({
                    defaultEmailAlertList: []
                });
            }
        }
        this.setState(prevState => {
            return {
                ...prevState,
                selectedEmailList: sliderEmailList
            };
        });
        this.toggleAddRecipientsSlider(event);
    };

    defaultEmailSelectionHandler = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                defaultEmailSelection: !prevState.defaultEmailSelection,
            };
        });
    };

    shouldDisableEmailTooltip = (i) => {
        let element = document.getElementById("addRecipientsUserEmail_" + i);
        if(element) {
            return element.offsetWidth < element.scrollWidth ? false : true;
        }
        return true;
    };

    addRecipientsEmailSort = (event) => {
        this.setState(prevState => {
            let sliderEmailList = prevState.sliderEmailList;
            this.emailSort(sliderEmailList);
            return {
                ...prevState,
                sliderEmailSortOrder: !prevState.sliderEmailSortOrder,
                sliderEmailList: sliderEmailList
            };
        });
    };

    emailSort = (emailList) => {
        if(this.state.sliderEmailSortOrder) {
            emailList.sort((d1, d2) => {
                let e1 = d1.email.split("@", 1)[0].toLowerCase();
                let e2 = d2.email.split("@", 1)[0].toLowerCase();
                if(e1 < e2) return 1;
                if(e1 > e2) return -1;
                return 0;
            });
        } else {
            emailList.sort((d1, d2) => {
                let e1 = d1.email.split("@", 1)[0].toLowerCase();
                let e2 = d2.email.split("@", 1)[0].toLowerCase();
                if(e1 < e2) return -1;
                if(e1 > e2) return 1;
                return 0;
            });
        }
    };

    listSelectedEmails = () => {
        let lastEmail;
        let emailList = this.state.users.filter((val, idx) => this.state.selectedEmailList[idx]).map((user, idx) => {
            lastEmail = user.email;
            return <span key={ idx }>{ user.email }, </span>;
        });
        if(emailList.length > 0) emailList[emailList.length - 1] = <span key={ emailList.length - 1 }>{ lastEmail } </span>;
        return emailList;
    };

    listSelectedEmailButtons = () => {
        return this.state.users.map((user, idx) => {
            return (
                <div key={ idx } className="thisEmailDetails" style={ { display: this.state.selectedEmailList[idx] ? "block" : "none" } }>
                    <span className="thisEmailAddr">{ user.email }</span>
                    <span className="removeEmail" data-for={ "removeEmail_" + idx } data-tip data-toggle="tooltip" data-placement="top" data-original-title="Remove" onClick={ event => this.emailButtonCloseHandler(event, idx) } tabIndex={ 0 }></span>
                    <ReactTooltip id={ 'removeEmail_' + idx } place="top" effect='solid'>Remove</ReactTooltip>
                </div>
            );
        });
    };

    slackConnectHandler = (event) => {
        event.preventDefault();
        let slackAppState = SLACK_APP_STATE;
        slackAppState.uuid = this.state.userId;
        const SLACK_QUERY_PARAMS = {
            client_id: SLACK_CLIENT_ID,
            scope: SLACK_BOT_SCOPES,
            user_scope: SLACK_USER_SCOPES,
            redirect_uri: SLACK_REDIRECT_URI,
            state: encodeURI(Buffer.from(JSON.stringify(slackAppState)).toString('base64'))
        };
        const popup = this.popup = SlackPopupWindow.open(
            "slack-oauth-popup",
            SLACK_OAUTH_URL + toQuery(SLACK_QUERY_PARAMS),
            { target: "_blank", height: 1000, width: 600, left: 600 }
        );

        popup.then(data => {
            let count = this.state.slackWebhooks ? this.state.slackWebhooks.length : 0;
            this.getSlackWebhooks(count);
        }, error => {
            if(error?.code) {
                if(error?.type === "slack") {
                    this.setState({
                        message: "The slack server could not complete your operation(s) without encountering an error, likely due to a transient issue on their end.",
                        msgType: "error"
                    });
                } else {
                    this.setState({
                        message: error?.details ? decodeURIComponent(error.details) : String(getMessage(error.code)).replace("$action$", "slack integration"),
                        msgType: "error"
                    });
                }
                return;
            }
            this.setState({
                message: "Error while integrating slack webhook, please try again!",
                msgType: "error"
            });
        });
    };

    webhookSelectHandler = (event, idx) => {
        this.setState(prevState => {
            let slackWebhooksNew = prevState.slackWebhooks;
            slackWebhooksNew[idx].isSelected = !slackWebhooksNew[idx].isSelected;
            return {
                ...prevState,
                slackWebhooks: slackWebhooksNew
            };
        });
    };

    enableSlackUnlinkPopup = (event, idx) => {
        event.preventDefault();
        this.setState({
            isAction: true,
        });
        let dWebhook = this.state.slackWebhooks[idx].data;
        if(this.state.eventAlarm && this.state.eventAlarm.slackWebhooks.filter((eWebhook, i) => eWebhook.id === dWebhook.id).length !== 0) {
            this.setState({
                isUnlinkSlackPopupActive: true,
                unlinkSlackChannelIdx: idx,
                isAction: false
            });
            $("main").attr("style", "position: fixed");
        } else {
            this.deleteWebhook(event, idx);
        }
    };

    deleteWebhook = (event, idx) => {
        event.preventDefault();
        this.setState({
            isAction: true,
        });
        SlackService.deleteWebhook(this.state.userId, this.state.slackWebhooks[idx].data.id).then(resp => {
            let data = resp.data;
            if(data.ok) {
                let slackWebhooks = this.state.slackWebhooks;
                let dWebhook = slackWebhooks[idx].data;
                slackWebhooks = slackWebhooks.filter((webhook, i) => i !== idx);
                this.setState(prevState => {
                    let eventAlarm = prevState.eventAlarm;
                    if(prevState.eventAlarm) {
                        let eventSlackWebhooks = eventAlarm.slackWebhooks.filter((eWebhook, idx) => eWebhook.id !== dWebhook.id);
                        eventAlarm.slackWebhooks = eventSlackWebhooks;
                    }
                    return {
                        message: data.message ? data.message : "Successfully unlinked slack integration.",
                        msgType: "success",
                        eventAlarm: prevState.eventAlarm ? eventAlarm : null,
                        slackWebhooks: slackWebhooks,
                        isAction: false,
                        isUnlinkSlackPopupActive: false
                    };
                });
                $("main").removeAttr("style");
            } else {
                console.log(data.error);
                this.setState({
                    message: data.details ? data.details : "Error occurred while performing action. Please try again.",
                    msgType: "error",
                    isAction: false,
                    isUnlinkSlackPopupActive: false
                });
                $("main").removeAttr("style");
            }
        }).catch(error => {
            if(error?.response?.data) {
                let data = error.response.data;
                console.log(data.error);
                if(error.response.data?.alarms) {
                    console.log(error.response.data.alarms);
                    this.setState({
                        message: data.details ? data.details : "The webhook to be deleted is the only notification channel for events, please reassign the integration before unlinking.",
                        msgType: "error",
                        isAction: false,
                        isUnlinkSlackPopupActive: false
                    });
                    $("main").removeAttr("style");
                } else {
                    this.setState({
                        message: data.details,
                        msgType: "error",
                        isAction: false,
                        isUnlinkSlackPopupActive: false
                    });
                    $("main").removeAttr("style");
                }
            } else {
                console.log(error);
                this.setState({
                    message: "Error occurred while performing action. Please try again.",
                    msgType: "error",
                    isAction: false,
                    isUnlinkSlackPopupActive: false
                });
                $("main").removeAttr("style");
            }
        });
    };

    validateAndConstructEventAlarm = () => {
        let alarmConfig = JSON.parse(JSON.stringify(this.state.eventAlarm));
        alarmConfig.emailList = this.state.users.filter((val, idx) => this.state.selectedEmailList[idx]).map(user => user.email);
        alarmConfig.slackWebhooks = this.state.slackWebhooks.filter(webhook => webhook.isSelected === true).map(webhook => webhook.data);
        let eventEmailList = this.state.eventAlarm.emailList ? this.state.eventAlarm.emailList : [];
        let eventWebhooks = this.state.eventAlarm.slackWebhooks ? this.state.eventAlarm.slackWebhooks : [];
        if(alarmConfig.emailList.length !== eventEmailList.length) return alarmConfig;
        else {
            alarmConfig.emailList.forEach(email => {
                if(eventEmailList.find(sEmail => sEmail === email) === undefined)
                    return alarmConfig;
            });
        }
        if(alarmConfig.slackWebhooks.length !== eventWebhooks.length) return alarmConfig;
        else {
            alarmConfig.slackWebhooks.forEach(webhook => {
                if(eventWebhooks.find(eWebhook => eWebhook.id === webhook) === undefined)
                    return alarmConfig;
            });
        }
        return false;
    };

    saveEventAlarmHandler = (event) => {
        this.setState({
            isAction: true,
        });
        if(this.state.isEventAlarmEnabled) {
            let alarmConfig = this.validateAndConstructEventAlarm();
            if(!alarmConfig) {
                this.setState({
                    message: "Please make modification(s) to update event based alarm configuration!",
                    msgType: "error",
                    isAction: false,
                });
                return;
            }
            AlarmService.updateAlarm(this.state.userId, alarmConfig).then(resp => {
                let data = resp.data;
                if(data.ok) {
                    this.setState({
                        message: data.message ? data.message : "Successfully updated configuration",
                        msgType: "success",
                        isEventAlarmEnabled: true,
                        eventAlarm: data.alarm,
                        isAction: false,
                    });
                } else {
                    console.log(data.error);
                    this.setState({
                        message: data.details ? data.details : "Error occurred while performing action. Please try again.",
                        msgType: "error",
                        isAction: false,
                    });
                }
            }).catch(error => {
                if(error?.response?.data) {
                    let data = error.response.data;
                    console.log(data.error);
                    if(String(data.error).toLowerCase() === "empty_channel") data.details = "Please select active mode(s) of notification for modifying event based alarm configuration!";
                    this.setState({
                        message: data.details,
                        msgType: "error",
                        isAction: false,
                    });
                } else {
                    console.log(error);
                    this.setState({
                        message: "Error occurred while performing action. Please try again.",
                        msgType: "error",
                        isAction: false,
                    });
                }
            });
        } else {
            let alarmConfig = {
                type: "event",
                userId: this.state.userId,
                emailList: this.state.users.filter((user, idx) => this.state.selectedEmailList[idx]).map(user => user.email),
                slackWebhooks: this.state.slackWebhooks.filter(webhook => webhook.isSelected).map(webhook => webhook.data)
            };
            if(alarmConfig.emailList.length === 0 && alarmConfig.slackWebhooks.length === 0) {
                this.setState({
                    message: "Please select active mode(s) of notification for enabling event based alarm configuration!",
                    msgType: "error",
                    isAction: false,
                });
                return;
            }
            AlarmService.createAlarm(this.state.userId, alarmConfig).then(resp => {
                let data = resp.data;
                if(data.ok) {
                    if(data.alarm) {
                        this.setState(prevState => {
                            return {
                                ...prevState,
                                message: data.message ? data.message : "Successfully created event based alarm",
                                msgType: "success",
                                isEventAlarmEnabled: true,
                                eventAlarm: data.alarm,
                                isAction: false,
                            };
                        });
                    }
                } else {
                    console.log(data.error);
                    this.setState({
                        message: data.details ? data.details : "Error occurred while performing action. Please try again.",
                        msgType: "error",
                        isAction: false,
                    });
                }
            }).catch(error => {
                if(error?.response?.data) {
                    let data = error.response.data;
                    console.log(data.error);
                    this.setState({
                        message: data.details,
                        msgType: "error",
                        isAction: false,
                    });
                } else {
                    console.log(error);
                    this.setState({
                        message: "Error occurred while performing action. Please try again.",
                        msgType: "error",
                        isAction: false,
                    });
                }
            });
        }
    };

    disableEventAlarmHandler = (event) => {
        this.setState({
            isAction: true,
        });
        let params = {
            id: this.state.eventAlarm.id
        };
        AlarmService.deleteAlarm(this.state.userId, params).then(resp => {
            let data = resp.data;
            if(data.ok) {
                this.setState(prevState => {
                    let slackWebhooks = prevState.slackWebhooks;
                    slackWebhooks.forEach(webhook => webhook.isSelected = false);
                    let emailList = this.state.users.map(user => false);
                    let defaultEmailList = localStorage.getItem("defaultEmailSelectionAlertPolicy") ? Array(...localStorage.getItem("defaultEmailSelectionAlertPolicy").split(",")) : [];
                    if(defaultEmailList.length > 0) {
                        emailList = emailList.map((email, idx) => defaultEmailList.find(val => val === String(this.state.users[idx].id)) !== undefined);
                    } else {
                        emailList = emailList.map((email, idx) => localStorage.getItem("userId") === String(this.state.users[idx].id));
                    }
                    return {
                        ...prevState,
                        message: data?.message ? data.message : "Successfully disabled event based alarm.",
                        msgType: "success",
                        isAction: false,
                        isEventAlarmEnabled: false,
                        eventAlarm: null,
                        selectedEmailList: emailList,
                        slackWebhooks: slackWebhooks
                    };
                });
            } else {
                console.log(data.error);
                this.setState({
                    message: data?.details ? data.details : "Failed to disable event based alarm!",
                    msgType: "error",
                    isAction: false
                });
            }
        }).catch(err => {
            if(err?.response?.data) {
                let data = err.response.data;
                console.log(data.error);
                this.setState({
                    message: data.details,
                    msgType: "error",
                    isAction: false,
                });
            } else {
                console.log(err);
                this.setState({
                    message: "Error occurred while performing action. Please try again.",
                    msgType: "error",
                    isAction: false,
                });
            }
        });
    };

    refreshScrollBar = (event) => {
        this.scrollTop();
        this.setState({
            addRecipientsSliderMaxHeight: window.visualViewport.height - 411,
        });
    };

    scrollBarFocusHandler = (event) => {
        let opacity;
        if(event.type === 'mouseenter') {
            opacity = "1";
        } else if(event.type === 'mouseleave') {
            opacity = "0";
        }
        this.setState({
            scrollBarOpacity: opacity
        });
    };

    scrollTop = (event) => {
        if(this.scrollRef && this.scrollRef.current && this.scrollRef.current.scrollArea) {
            this.scrollRef.current.scrollArea.scrollTop();
        }
    };

    sortClickHandler = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };

    slackCSS = {
        sli0: { fill: '#2EB67D', },
        sli1: { fill: '#36C5F0' },
        sli2: { fill: '#E01E5A', },
        sli3: { fill: '#ECB22E', },
    };

    openApplicationCred = (event) => {
        this.setState({
            openAppCred: true,
            isNeverExpire: false,
            credName: "",
            credDesc: "",
            expirationDate: "",
            expirationTime: "",
            credNameError: "",
            credDescError: "",
            credDateError: "",
            credTimeError: "",
            showSuccessPopup: false
        });

        setTimeout(() => {
            this.credNameRef.current.focus();
        }, 100);
        $("body").addClass("popup_no_scroll");
    };

    openDeleteCred = (event, cred) => {
        this.setState({
            deleteAppCred: true,
            currentDeleteUser: cred,
            showSuccessPopup: false
        });
        $("body").addClass("popup_no_scroll");
    };

    closeAppCred = (param) => {
        if(param === "appSlider") {
            this.setState({
                openAppCred: false
            });
        }
        else {
            this.setState({
                showSuccessPopup: false
            });
        }
        $("body").removeClass("popup_no_scroll");

    };

    handleCredFields = (e) => {
        let name = e.target.name;
        let val = e.target.value;
        this.setState({
            [name]: val,
            credNameError: "",
            credDescError: ""
        });
    };

    createAppCred = (e) => {
        if(this.state.isUserSubscribed) {
            this.setState({
                isRedirectToCCPage: true
            });
            return;
        }
        if(this.state.credName.trim().length <= 0) {
            this.setState({
                credNameError: "Name cannot be blank"
            });
            this.credNameRef.current.focus();
            return;
        }
        if(this.state.credName.trim().length > 0) {
            if(!Validate("firstName", this.state.credName)) {
                this.setState({
                    credNameError: "Name can contains a-z, A-Z, -, _ characters"
                });
                this.credNameRef.current.focus();
                return;
            }
        }
        if(!this.state.isNeverExpire) {
            if(this.state.expirationDate.length <= 0) {
                this.setState({
                    credDateError: "Expiration date cannot be blank"
                });
                return;
            }
            if(this.state.expirationTime.length <= 0) {
                this.setState({
                    credTimeError: "Expiration time cannot be blank"
                });
                return;
            }
        }
        if(this.state.credDesc.trim().length > 0) {
            if(!Validate("textArea", this.state.credDesc)) {
                this.setState({
                    credDescError: "Description can contains a-z, A-Z,1-9, -, _ characters"
                });
                this.credDescRef.current.focus();
                return;
            }
        }
        this.setState({
            isAction: true
        });
        let requestBody = {};
        if(this.state.isNeverExpire) {
            requestBody = {
                name: this.state.credName,
                description: this.state.credDesc
            };
        }
        else {
            requestBody = {
                name: this.state.credName.trim(),
                expires_at: this.convertToDateTimeFormat(this.state.expirationDate, this.state.expirationTime),
                description: this.state.credDesc.trim()
            };
        }

        ApplicationService.createApplicationCredential(JSON.stringify(requestBody)).then(resp => {

            this.setState({
                isAction: false
            });
            resp = resp.data;
            if(resp === "EXPIRES_AT_ERROR") {
                this.setState({
                    credTimeError: "Please select a valid time"
                });
            }
            else if(resp === "DUPLICATE_NAME_ERROR") {
                this.setState({
                    credNameError: "Duplicate name found"
                });
                this.credNameRef.current.focus();
            }
            else if(resp === "USER_NOT_FOUND") {
                this.setState({
                    message: "Error while creating user credentials, Please try again after some time",
                    msgType: "error"
                });
            }
            else if(resp === "ERROR_OCCURED") {
                this.setState({
                    message: "Error while creating user credentials, Please try again after some time",
                    msgType: "error"
                });
            }
            else if(resp != null) {
                this.setState({
                    currentId: resp.id,
                    currentSecret: resp.secret,
                    currentEmail: resp.name,
                    showSuccessPopup: true,
                    dataCached: false
                }, () => {
                    this.closeAppCred("appSlider");
                    this.getApplicationCredentials();
                });
                $("body").removeClass("popup_no_scroll");


            }
            else {
                this.setState({
                    message: "Error while creating user credentials, Please try again after some time",
                    msgType: "error"
                });
                this.closeAppCred("appSlider");
                $("body").removeClass("popup_no_scroll");

            }
            this.closeToastMessage();

        })
            .catch(error => {
                this.setState({
                    message: "Error while creating user credentials, Please try again after some time",
                    msgType: "error",
                    isAction: false
                });
                this.closeAppCred("appSlider");

            });
    };

    convertToDateTimeFormat = (date, time) => {
        let timeDate = new Date(time);
        let hr = timeDate.getHours();
        let mn = timeDate.getMinutes();
        let sec = timeDate.getSeconds();
        let onlyTime = hr + ":" + mn + ":" + sec;
        let dateTime = this.formatDate(date).replace(/-/g, '/') + " " + onlyTime;
        let formatDate = new Date(dateTime);
        return formatDate.toISOString();
    };

    padTo2Digits = (num) => {
        return num.toString().padStart(2, '0');
    };

    formatDate = (date) => {
        return [
            date.getFullYear(),
            this.padTo2Digits(date.getMonth() + 1),
            this.padTo2Digits(date.getDate()),
        ].join('-');
    };

    copyToclipboard = (event, text) => {
        this.setState({
            isCopied: true
        });
        var container = event.currentTarget;
        let tempInnerHtml = container.innerHTML;
        container.innerHTML = text;
        window.getSelection().removeAllRanges();
        let range = document.createRange();
        range.selectNode(container);
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        container.innerHTML = tempInnerHtml;
    };

    downLoadData = (event, type) => {
        event.preventDefault();
        let dataString = "";
        let commentedData = "";
        let fileName = "";
        if(type === "yaml") {
            commentedData = "# This is a clouds.yaml file, which can be used by OpenStack tools as a source\n";
            commentedData += "# of configuration on how to connect to a cloud.If this is your only cloud\n";
            commentedData += "# just put this file in ~/.config/openstack / clouds.yaml and tools like\n";
            commentedData += "# python - openstackclient will just work with no further config. (You will need\n";
            commentedData += "# to add your password to the auth section) \n";
            commentedData += "# If you have more than one cloud account, add the cloud entry to the clouds\n";
            commentedData += "# section of your existing file and you can refer to them by name with\n";
            commentedData += "# OS_CLOUD=openstack or--os - cloud=openstack\n";
            let data = {
                clouds: {
                    openstack: {
                        auth: {
                            auth_url: "https://identity.api.idrivecompute.io/v3",

                            application_credential_id: this.state.currentId,
                            application_credential_secret: this.state.currentSecret
                        },
                        region_name: "LA3",
                        interface: "public",
                        identity_api_version: 3,
                        auth_type: "v3applicationcredential"
                    }
                }
            };


            dataString = yaml.dump(data);
            fileName = "IDriveCompute_Application_Credentials.yaml";
        }
        else {
            dataString = "#!/usr/bin/env bash;\n";
            dataString += "\n";
            dataString += "export OS_AUTH_TYPE=v3applicationcredential\n";
            dataString += "export OS_AUTH_URL=https://identity.api.idrivecompute.io/v3\n";
            dataString += "export OS_IDENTITY_API_VERSION=3\n";
            dataString += "export OS_REGION_NAME=LA3\n";
            dataString += "export OS_INTERFACE=public\n";
            dataString += "export OS_APPLICATION_CREDENTIAL_ID=" + this.state.currentId + "\n";
            dataString += "export OS_APPLICATION_CREDENTIAL_SECRET=" + this.state.currentSecret + "\n";
            fileName = "IDriveCompute_Application_Credentials.sh";
        }
        const element = document.createElement("a");
        const file = new Blob([commentedData + dataString],
            { type: 'text/plain;charset=utf-8' });
        element.href = URL.createObjectURL(file);
        element.download = fileName;
        document.body.appendChild(element);
        element.click();
    };


    deleteUserAppCred = () => {
        this.setState({
            isAction: true,
            deleteAppCred: false
        });
        $("body").removeClass("popup_no_scroll");
        ApplicationService.deleteApplicationCredential(this.state.currentDeleteUser.id, this.state.currentDeleteUser.name).then(resp => {
            resp = resp.data;
            if(resp === "DELETED_SUCCESFULLY") {
                this.setState({
                    message: "User application credentials has been deleted successfully",
                    msgType: "success",
                    isAction: false,
                    dataCached: false
                }, () => {
                    this.getApplicationCredentials();
                });

            }
            else {
                this.setState({
                    message: "Error while deleting user credentials, Please try again after some time",
                    msgType: "error",
                    isAction: false
                });
            }
            this.closeToastMessage();
        })
            .catch(error => {
                this.setState({
                    message: "Error while deleting user credentials, Please try again after some time",
                    msgType: "error",
                    isAction: false
                });
            });
    };

    closeToastMessage = () => {
        setTimeout(() => {
            this.setState({
                message: "",
                msgType: ""
            });
        }, 10000);

    };
    sortAppData = (event, source) => {
        let toSort;
        let bool1 = $(event.currentTarget).find('.sort_icon').hasClass('toggle_sort');
        if(bool1) {
            $(event.currentTarget).find('.sort_icon').removeClass('toggle_sort');
            toSort = "ascending";
        }
        else {
            let bool2 = $(event.currentTarget).find('.sort_icon').hasClass('active');
            if(bool2) {
                $(event.currentTarget).find('.sort_icon').addClass('toggle_sort');
                toSort = "descending";
            }
            else {
                if($('.sort_icon').hasClass('toggle_sort')) {
                    $('.sort_icon').removeClass('active toggle_sort');
                }
                if($('.sort_icon').hasClass('active')) {
                    $('.sort_icon').removeClass('active ');
                }
                $(event.currentTarget).find('.sort_icon').addClass('active toggle_sort');
                toSort = "descending";
            }
        }
        this.sortdataBasedOnKey(this.state.credData, source, toSort);
    };

    sortdataBasedOnKey = (data, key, order) => {
        let sortedList = [];
        if(key === "expires") {
            let expires = [];
            let notExpires = [];
            data.forEach(item => {
                if(item.expires === 'Never') notExpires.push(item);
                else expires.push(item);
            });
            expires.sort((a, b) => {
                let curr = new Date(a[key]);
                let next = new Date(b[key]);

                if(order == "descending") {
                    return curr - next;
                }
                else {
                    return next - curr;
                }
            });
            if(order == "descending") {
                sortedList = expires.concat(notExpires);
            }
            else {
                sortedList = notExpires.concat(expires);
            }
            let credDataPaged = [...sortedList];
            if(credDataPaged.length > this.state.count) credDataPaged = credDataPaged.slice(0, this.state.count);
            this.setState({
                credData: sortedList,
                credDataPaged: credDataPaged,
                indexCount: 0
            });
        }
        else {

            data.sort((a, b) => {
                let curr = a[key];
                let next = b[key];
                if(order == "descending") {
                    return (curr < next) ? -1 : ((curr > next) ? 1 : 0);
                }
                else {
                    return (curr > next) ? -1 : ((curr < next) ? 1 : 0);
                }
            });
            let credDataPaged = [...data];
            if(credDataPaged.length > this.state.count) credDataPaged = credDataPaged.slice(0, this.state.count);
            this.setState({
                credData: data,
                credDataPaged: credDataPaged,
                indexCount: 0
            });
        }


    };

    handleNextClick = (event) => {
        let credData = this.state.credData;
        let indexCount = this.state.indexCount + this.state.count;
        let endCount = indexCount + this.state.count;
        if(endCount > credData.length) endCount = credData.length;
        this.setState({
            indexCount: indexCount,
            credDataPaged: credData.slice(indexCount, endCount)
        });
        event.preventDefault();
    };

    handlePreviousClick = (event) => {
        let credData = this.state.credData;
        let indexCount = this.state.indexCount - this.state.count;
        this.setState({
            indexCount: this.state.indexCount - this.state.count,
            credDataPaged: credData.slice(indexCount, this.state.indexCount)
        });
        event.preventDefault();
    };




    render() {
        const { classes } = this.props;
        if(localStorage.getItem("roleId") === "1") {
            return <Redirect to="/error"></Redirect>;
        }
        if(this.state.isRedirectToCCPage) {
            return <Redirect to={ {
                pathname: "/billing/creditcard",
                state: { message: true }
            } }></Redirect>;
        }
        return (
            <div>
                <div className="main_nav_module setting_main_module">
                    <main>
                        <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                            <div className="loader_icon"></div>
                        </div>
                        <LeftNav isActive={ 'settings' }></LeftNav>
                        <div className="main_container">
                            <header className="header_wrap">
                                <HeaderTop showCreate={ true } isUserSubscribed={ this.state.isUserSubscribed }></HeaderTop>
                                <div className="header_wrap_bottom">
                                    <div className="bottom_navbar">
                                        <div className="bn_left">
                                            <div className="computer_no">
                                                <span className="text bold_600">Settings</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </header>
                            <NotificationSlider />

                            <section className="main_section">
                                <div className="main_body_container">
                                    <div className="mainBody_colWrap">
                                        <div className="settings_container">
                                            <div className="setting_tab_wrap">
                                                <div className="custom_tabs_wrap">
                                                    <ul>
                                                        <li id="preferences" className={ this.state.isActive === 'preferences' ? "preference active" : "preference" } tabIndex={ 0 } onClick={ () => this.tabClickHandler("preferences") }>
                                                            <span className="svg_wrap">
                                                                <svg version="1.1" x="0px" y="0px" width="21.3px" height="17.1px" viewBox="0 0 21.3 17.1" style={ { enableBackground: "new 0 0 21.3 17.1" } } xmlSpace="preserve">
                                                                    <g>
                                                                        <line className="pf0" x1="2.6" y1="5.2" x2="18.6" y2="5.2"></line>
                                                                        <circle className="pf1" cx="7.3" cy="5.2" r="2.8"></circle>
                                                                        <line className="pf0" x1="18.6" y1="11.9" x2="2.6" y2="11.9"></line>
                                                                        <circle className="pf1" cx="13.7" cy="11.9" r="2.8"></circle>
                                                                    </g>
                                                                </svg>
                                                            </span>
                                                            Preferences
                                                        </li>
                                                        <li id='app_cred' className={ this.state.isActive === "app_cred" ? "app_credential active" : "app_credential" } tabIndex={ 0 } onClick={ () => this.tabClickHandler("app_cred") }>
                                                            <span className="svg_wrap">
                                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 19.8 20.1" enableBackground='new 0 0 19.8 20.1' xmlSpace="preserve">
                                                                    <path className="apcre0" d="M11.2,18.2" />
                                                                    <path className="apcre1" d="M6,18.2H4.4c-1.3,0-2.3-1-2.3-2.3V4.5c0-1.3,1-2.3,2.3-2.3h9.1c1.3,0,2.3,1,2.3,2.3v2.7" />
                                                                    <g>
                                                                        <circle className="apcre2" cx="15.3" cy="12.4" r="2.5" />
                                                                        <line className="apcre2" x1="13" y1="14.1" x2="8.8" y2="18.3" />
                                                                        <path className="apcre3" d="M11.1,18.8l1.3-1.3c0.3-0.3,0.3-0.7,0-0.9l-0.8-0.8c-0.3-0.3-0.7-0.3-0.9,0l-1.3,1.3c-0.3,0.3-0.3,0.7,0,0.9
                                                                        l0.8,0.8C10.4,19.1,10.8,19.1,11.1,18.8z"/>
                                                                    </g>
                                                                    <line className="apcre1" x1="5.5" y1="5.7" x2="12.3" y2="5.7" />
                                                                    <line className="apcre1" x1="5.5" y1="9.1" x2="12.3" y2="9.1" />
                                                                    <line className="apcre1" x1="5.5" y1="12.5" x2="8.9" y2="12.5" />
                                                                </svg>
                                                            </span>Application Credential
                                                        </li>
                                                        <li id="security" className={ this.state.isActive === 'security' ? "security active" : "security" } tabIndex={ 0 } onClick={ () => this.tabClickHandler('security') }>
                                                            <span className="svg_wrap">
                                                                <svg x="0px" y="0px" viewBox="0 0 73.6 89.9" enableBackground="new 0 0 73.6 89.9" xmlSpace="preserve">
                                                                    <path fill="none" stroke="#A8ACB1" strokeWidth="6" d="M35.7,9.5L5.6,23.1v26.6c0,0-2,21.5,30.1,32.1c1.5,0,26.9-6.9,30.1-32.1  c0-2.9,0-26.6,0-26.6L35.7,9.5z"></path>
                                                                    <polyline fill="none" stroke="#A8ACB1" strokeWidth="6" strokeLinecap="round" points="21.7,44.2 32,54.5 49.7,36.7 " />
                                                                </svg>
                                                            </span>
                                                            Security
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className={ this.state.isActive === 'preferences' ? "preference_sec clearfix active" : "preference_sec clearfix" } style={ { display: this.state.isActive === 'preferences' ? '' : "none" } }>
                                                <div className="preference_sec_wrap">
                                                    {/** START Email Notification */ }
                                                    <div className="email_blk" style={ { display: "none" } }>
                                                        <h2>Email Notification</h2>
                                                        <div className="email_contBlk">
                                                            <p className="desc_txt">Receive notifications for activities in Email</p>
                                                            <div className="toggle-btn_wrap" style={ { display: "none" } }>
                                                                <label className="switch toggle_btn">
                                                                    <input type="checkbox" id="togBtn" checked={ this.state.emailToggle } onChange={ event => this.toggleEmailSelect(event) } />
                                                                    <div className="slider round">
                                                                        <span className="on">ON</span>
                                                                        <span className="off">OFF</span>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <div className="checkbx_wrap">
                                                            <div className="common_txtBox_row">
                                                                <label className="checkBox applyToall active">
                                                                    <input type="checkbox" name="applytoall" value="true" disabled={ true } defaultChecked={ true } />
                                                                    <span className="checkmark"></span>
                                                                    <div className="add_on_head">Email alerts for instance activities
                                                                        <span className="info_img" data-for="instanceActivityInfoMsg" data-tip data-toggle="tooltip" data-placement="top" title="" data-original-title="Receive notifications for instance-related activities in the registered email address">
                                                                            <svg x="0px" y="0px" viewBox="0 0 24.5 22.3" style={ { enableBackground: "0 0 24.5 22.3", fillRule: "evenodd", clipRule: "evenodd", fill: "#88A2BE" } } xmlSpace="preserve">
                                                                                <path className="info_icn" d="M12.2,21.1c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10C22.2,16.6,17.8,21.1,12.2,21.1z   M13.3,16.2v-7h-2v7H13.3z M11.3,6.2v2h2v-2H11.3z"></path>
                                                                            </svg>
                                                                        </span>
                                                                        <ReactTooltip id='instanceActivityInfoMsg' place='right' effect='solid'>Receive notifications for instance-related activities <br />in the registered email address</ReactTooltip>
                                                                    </div>
                                                                </label>

                                                            </div>
                                                            <div className="common_txtBox_row">
                                                                <label className="checkBox applyToall active">
                                                                    <input type="checkbox" name="applytoall" value="true" disabled={ true } defaultChecked={ true } />
                                                                    <span className="checkmark"></span>
                                                                    <div className="add_on_head">Email alerts for account activities
                                                                        <span className="info_img" data-for="accountActivityInfoMsg" data-tip data-toggle="tooltip" data-placement="top" title="" data-original-title="Receive notifications for account-related activities in the registered email address">
                                                                            <svg x="0px" y="0px" viewBox="0 0 24.5 22.3" style={ { enableBackground: "0 0 24.5 22.3", fillRule: "evenodd", clipRule: "evenodd", fill: "#88A2BE" } } xmlSpace="preserve">
                                                                                <path className="info_icn" d="M12.2,21.1c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10C22.2,16.6,17.8,21.1,12.2,21.1z   M13.3,16.2v-7h-2v7H13.3z M11.3,6.2v2h2v-2H11.3z"></path>
                                                                            </svg>
                                                                        </span>
                                                                        <ReactTooltip id='accountActivityInfoMsg' place='right' effect='solid'>Receive notifications for account-related activities <br /> in the registered email address</ReactTooltip>
                                                                    </div>
                                                                </label>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/** END Email Notification */ }
                                                    {/** START Event Based Alerts */ }
                                                    <div className="slack_blk">
                                                        <div className="slack_contBlk">
                                                            <h2>Event-based Notifications</h2>
                                                            <p className="desc_txt">Send notifications to individual recipients</p>
                                                            <div className="sblk_wrap">
                                                                <div className="common_txtBox_row">
                                                                    <div className="ctr_wrap">
                                                                        <div className="ctr_wrap_box">
                                                                            <label className="checkBox applyToall" style={ { display: "none" } }>
                                                                                <input className="checkbox" name="applytoall" defaultValue={ false } disabled={ true } />
                                                                                <span className="checkmark"></span>
                                                                                <p className="add_on_head">Send notifications to individual recipients</p>
                                                                            </label>
                                                                            <span className="err_msg" style={ { display: "none" } }>error</span>
                                                                        </div>
                                                                        <p className="addRecipients" ref={ this.addRecipientsRef } tabIndex={ 0 } onClick={ (event) => this.toggleAddRecipientsSlider(event) } style={ { cursor: "pointer", pointerEvents: "auto", marginLeft: "0px" } }>{ this.state.selectedEmailList.filter(isSelected => !isSelected).length > 0 ? "Add recipients" : "Edit recipients" }</p>
                                                                    </div>
                                                                </div>
                                                                <div className="common_txtBox_row">
                                                                    <div className="sendReports">
                                                                        <div className="form-control-static" id="savedEmailReportsAddress">
                                                                            { this.listSelectedEmailButtons() }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="wrap_slack_channel">
                                                            <div className="wsc_wrap_title">
                                                                <p className="desc_txt">Send notifications to slack channels</p>
                                                            </div>
                                                            <div className="btn-blk">
                                                                <button type='submit' className="common_cta_btn connectSlack_btn" tabIndex={ 0 } onClick={ this.slackConnectHandler } onFocus={ (event) => { console.debug("focus"); } }>
                                                                    <svg x="0px" y="0px" viewBox="0 0 56.7 56.7" style={ { enableBackground: "0 0 56.7 56.7" } } xmlSpace="preserve">
                                                                        <g>
                                                                            <path className="sl0" d="M35.5,7.3c-0.7-2.2-3.1-3.5-5.4-2.7c-2.2,0.7-3.5,3.1-2.7,5.4l11,34c0.8,2.1,3,3.3,5.2,2.6 c2.3-0.7,3.6-3.1,2.9-5.3L35.5,7.3"></path>
                                                                            <path className="sl1" d="M18.4,12.9c-0.7-2.2-3.1-3.5-5.4-2.7c-2.2,0.7-3.5,3.1-2.7,5.4l11,34c0.8,2.1,3,3.3,5.2,2.6 c2.3-0.7,3.6-3.1,2.9-5.3L18.4,12.9"></path>
                                                                            <path className="sl2" d="M49.4,35.5c2.2-0.7,3.5-3.1,2.7-5.4c-0.7-2.2-3.1-3.5-5.4-2.7l-34,11c-2.1,0.8-3.3,3-2.6,5.2 c0.7,2.3,3.1,3.6,5.3,2.9L49.4,35.5"></path>
                                                                            <path className="sl3" d="M19.8,45.1l8.1-2.6l-2.6-8.1l-8.1,2.6L19.8,45.1"></path>
                                                                            <path className="st4" d="M43.8,18.4c2.2-0.7,3.5-3.1,2.7-5.4c-0.7-2.2-3.1-3.5-5.4-2.7l-34,11c-2.1,0.8-3.3,3-2.6,5.2 c0.7,2.3,3.1,3.6,5.3,2.9L43.8,18.4"></path>
                                                                            <path className="sl5" d="M14.3,28c2.2-0.7,5.1-1.6,8.1-2.6c-1-3.1-1.9-5.9-2.6-8.1l-8.1,2.6L14.3,28"></path>
                                                                            <path className="sl6" d="M31.4,22.4l8.1-2.6c-0.9-2.7-1.8-5.4-2.6-8.1l-8.1,2.6L31.4,22.4"></path>
                                                                        </g>
                                                                    </svg>
                                                                    Connect with Slack
                                                                </button>
                                                            </div>
                                                            <div className="wsc_innerwrap">
                                                                <ul>
                                                                    {
                                                                        this.state.slackWebhooks.map((webhook, i) =>
                                                                            <li className="tr" key={ i }>
                                                                                <div className="common_txtBox_row" style={ { paddingBottom: "20px" } }>
                                                                                    <label className="checkBox applyToAll active">
                                                                                        <input type="checkbox" className="webhookChkBox" id={ "chkBox_" + i } checked={ webhook.isSelected } onChange={ (event) => this.webhookSelectHandler(event, i) }></input>
                                                                                        <span className="checkmark"></span>
                                                                                        <p className="add_on_head">
                                                                                            <span>Slack to { webhook.data.channelName }, { webhook.data.teamName }</span> &nbsp;
                                                                                            <a className="unlink" role={ "button" } onClick={ event => this.enableSlackUnlinkPopup(event, i) }>Unlink</a>
                                                                                        </p>
                                                                                    </label>
                                                                                    <span className="err_msg" style={ { display: this.state.showWebhookErrMsg ? 'block' : 'none' } }>{ this.state.webhookErrMsg }</span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    }
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="btn_blks">
                                                        {
                                                            this.state.isEventAlarmEnabled
                                                                ?
                                                                (() => {
                                                                    let isEnabled = this.validateAndConstructEventAlarm();
                                                                    return (
                                                                        <>
                                                                            <input type="button" name="saveBtn" value={ "Save changes" } className={ isEnabled ? "common_cta_btn blue btn_save" : "common_cta_btn blue btn_save disabled" } disabled={ isEnabled ? false : true } tabIndex={ isEnabled ? 1 : -1 } onClick={ (event) => this.saveEventAlarmHandler(event) } />
                                                                            <input type="button" name="disableBtn" value={ "Disable alerts" } className="common_cta_btn btn_danger" style={ { display: this.state.isEventAlarmEnabled ? "block" : "none" } } onClick={ (event) => this.disableEventAlarmHandler(event) } />
                                                                        </>
                                                                    );
                                                                })()
                                                                :
                                                                (() => {
                                                                    let isEnabled = this.state.selectedEmailList.filter(isSelected => isSelected).length > 0 || this.state.slackWebhooks.filter(webhook => webhook.isSelected).length > 0;
                                                                    return (
                                                                        <input type="button" name="saveBtn" value={ "Enable alerts" } className={ isEnabled ? "common_cta_btn blue btn_save" : "common_cta_btn blue btn_save disabled" } disabled={ isEnabled ? false : true } tabIndex={ isEnabled ? 1 : -1 } onClick={ (event) => this.saveEventAlarmHandler(event) } />
                                                                    );
                                                                })()

                                                        }
                                                    </div>
                                                    {/** END Event Based Alerts */ }
                                                </div>
                                            </div>

                                            <div className={ this.state.isActive === 'security' ? "security_sec clearfix active" : "security_sec clearfix" } style={ { display: this.state.isActive === 'security' ? '' : "none" } }>
                                                <div className="twofa_wrapper ">
                                                    <div className="twofa_box">
                                                        <h2>Two-factor Authentication for Users <span style={ { display: this.state.adminStatus === "ENABLED" ? "" : "none" } }>Configured for { this.state.total2faUsers } users out of { this.state.totalUsers }</span></h2>
                                                        { this.state.adminStatus === "ENABLED" ?
                                                            <p>Two-factor authentication safeguards your account against unauthorized sign ins. It is recommended to keep it enabled for your users.</p>
                                                            :
                                                            <p>Enable two-factor authentication for your users. This provides an additional layer of protection by using an OTP to authenticate all sign ins.</p> }
                                                        <button className="common_cta_btn blue enable2fa_btn" onClick={ () => this.enable2fapopup() }>{ this.state.adminStatus === "ENABLED" ? "Disable" : "Enable" }</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={ this.state.isActive === "app_cred" ? "appCredential_sec active" : "appCredential_sec" } style={ { display: this.state.isActive === 'app_cred' ? '' : "none" } }>
                                                <div className="appCredential_wrap">
                                                    <div className="appCredential_head">
                                                        <div className="appCredential_headLft">
                                                            <p> <a href='https://docs.idrivecompute.com/hc/en-us/articles/7001170922397-Introduction' target='_blank'>Refer this guide</a> to manage your IDrive® Compute resources programmatically using application credentials.</p>
                                                        </div>
                                                        <div className="appCredential_headRgt">
                                                            <div className="rhs_info"><p>Number of Credentials : { this.state.credData.length }</p></div>
                                                            <div className="divider" style={ { display: this.state.credData.length === 0 ? "none" : "" } }></div>
                                                            <div className="btn_wrap_icon" onClick={ (e) => this.openApplicationCred(e) } style={ { display: this.state.credData.length === 0 ? "none" : "" } }>
                                                                <button type="button" className="common_cta_btn blue createCredentialBtn">
                                                                    <span className="svg_wrap">
                                                                        <svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" d="M448.8,287.9H288.5v160.3c0,17.7-14.4,32.1-32.1,32.1l0,0  c-17.7,0-32.1-14.4-32.1-32.1V287.9H64.1c-17.7,0-32.1-14.4-32.1-32.1s14.4-32.1,32.1-32.1h160.3V63.5c0-17.7,14.4-32.1,32.1-32.1  l0,0c17.7,0,32.1,14.4,32.1,32.1v160.3h160.3c17.7,0,32.1,14.4,32.1,32.1S466.5,287.9,448.8,287.9z"></path>
                                                                        </svg>
                                                                    </span>Create Application Credential
                                                                </button>
                                                            </div>
                                                            <div className="srch_inpBox" style={ { display: "none" } }>
                                                                <input type="text" className="srch_inp" />
                                                                <div className="search_btn">
                                                                    <svg viewBox="0 0 26 26">
                                                                        <path className="cls-1" d="M11.33,5a6.33,6.33,0,1,0,6.34,6.32A6.32,6.32,0,0,0,11.33,5Zm0,10.84a4.52,4.52,0,1,1,4.52-4.52A4.52,4.52,0,0,1,11.33,15.85Z"></path><path className="cls-1" d="M14.3,15.58l1.28-1.28L21,19.72,19.73,21Z"></path>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tabular_data_wrap">
                                                        <div className="table_header">
                                                            <ul>
                                                                <li className="th">
                                                                    <div className="col col1" onClick={ (e) => this.sortAppData(e, "name") }>
                                                                        <div className="header_sort_wrap">Name<span className="sort_icon"></span></div>
                                                                    </div>
                                                                    <div className="col col2">
                                                                        <div>Description</div>
                                                                    </div>
                                                                    <div className="col col3" onClick={ (e) => this.sortAppData(e, "expires") }>
                                                                        <div className="header_sort_wrap">Expiration<span className="sort_icon"></span></div>
                                                                    </div>
                                                                    <div className="col col4">
                                                                        <div>ID</div>
                                                                    </div>
                                                                    <div className="col col5">
                                                                        <div>Actions</div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="table_data">
                                                            { !this.state.isAction && this.state.credData.length <= 0 ?
                                                                <div className="outer_empty_wrap fullPageEmpty">
                                                                    <div className="inner_empty_wrap">
                                                                        <div className="svg_wrap empty_icon appCreate_empty"></div>
                                                                        <p className="empty_head">Application Credential</p>
                                                                        <div className="cta_wrap" > <input type="button" className="common_cta_btn blue" value="Create Application Credential" onClick={ (e) => this.openApplicationCred(e) } /></div></div></div> :
                                                                <ul>
                                                                    { this.state.credDataPaged.map((cred, index) =>
                                                                        <li className="tr" key={ index }>
                                                                            <div className="col col1">
                                                                                <div className="cred_name">
                                                                                    <div className="name_icon">
                                                                                        <span className="svg_wrap">
                                                                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 19.8 20.1" enableBackground='new 0 0 19.8 20.1' xmlSpace="preserve">
                                                                                                <path className="apcrw0" d="M11.2,18.2"></path>
                                                                                                <path className="apcrw1" d="M6,18.2H4.4c-1.3,0-2.3-1-2.3-2.3V4.5c0-1.3,1-2.3,2.3-2.3h9.1c1.3,0,2.3,1,2.3,2.3v2.7"></path>
                                                                                                <g>
                                                                                                    <circle className="apcrw2" cx="15.3" cy="12.4" r="2.5"></circle>
                                                                                                    <line className="apcrw2" x1="13" y1="14.1" x2="8.8" y2="18.3"></line>
                                                                                                    <path className="apcrw3" d="M11.1,18.8l1.3-1.3c0.3-0.3,0.3-0.7,0-0.9l-0.8-0.8c-0.3-0.3-0.7-0.3-0.9,0l-1.3,1.3c-0.3,0.3-0.3,0.7,0,0.9
                                      l0.8,0.8C10.4,19.1,10.8,19.1,11.1,18.8z"></path>
                                                                                                </g>
                                                                                                <line className="apcrw1" x1="5.5" y1="5.7" x2="12.3" y2="5.7"></line>
                                                                                                <line className="apcrw1" x1="5.5" y1="9.1" x2="12.3" y2="9.1"></line>
                                                                                                <line className="apcrw1" x1="5.5" y1="12.5" x2="8.9" y2="12.5"></line>
                                                                                            </svg>
                                                                                        </span>
                                                                                    </div>
                                                                                    <span>{ cred.name }</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col col2" data-tip data-for={ cred.name }>{ cred.description }</div>
                                                                            { cred.description !== "N/A" && cred.description.length > 48 ?
                                                                                < ReactTooltip className={ classes["overrideMe"] } multiline={ true } id={ cred.name } place="right" effect='solid' >
                                                                                    { cred.description }
                                                                                </ReactTooltip>
                                                                                : null }

                                                                            <div className="col col3">{ cred.expires }</div>
                                                                            <div className="col col4" >
                                                                                <span className="id_value" data-tip data-for={ cred.id }>{ cred.id }</span>
                                                                                < ReactTooltip multiline={ true } id={ cred.id } place="top" effect='solid' >
                                                                                    { cred.id }
                                                                                </ReactTooltip>
                                                                                <div className="id_copy" data-tip data-for="idCopy" onClick={ (e) => this.copyToclipboard(e, cred.id) } onMouseLeave={ () => { this.setState({ isCopied: false }); } }>
                                                                                    <span className="svg_wrap" datatoggle="tooltip" dataoriginaltitle="Copy">
                                                                                        <svg x="0px" y="0px" width="14px" height="16.5px" viewBox="0 0 14 16.5" enableBackground="new 0 0 14 16.5" xmlSpace="preserve">
                                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#3B9FD8" d="M3.1,14.8v-11h10v11H3.1z M12.1,4.8h-8v9h8V4.8z M11.1,7.8h-6v-1h6  V7.8z M11.1,9.8h-6v-1h6V9.8z M9.1,11.8h-4v-1h4V11.8z M2.1,11.8h-1v-9v-1h1h8v1h-8V11.8z"></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </div>
                                                                                <ReactTooltip id="idCopy" place='right' effect='solid' >{ this.state.isCopied ? "Copied" : "Copy" }</ReactTooltip>
                                                                            </div>

                                                                            <div className="col col5">
                                                                                <button className="del_btn" data-tip data-for="deleteAppCred" onClick={ (e) => this.openDeleteCred(e, cred) }>
                                                                                    <ReactTooltip id="deleteAppCred" place='top' effect='solid'>Delete</ReactTooltip>

                                                                                    <span className="icon">
                                                                                        <svg x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18" xmlSpace="preserve">
                                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M16.1,3.3v12c0,1.1-0.9,2-2,2h-10c-1.1,0-2-0.9-2-2v-12h-1v-2h3h1  v-1h8v1h1h3v2H16.1z M14.1,3.3h-10v12h10V3.3z M8.1,13.3h-2v-8h2V13.3z M12.1,13.3h-2v-8h2V13.3z"></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </button>
                                                                            </div>
                                                                        </li>
                                                                    ) }
                                                                </ul>
                                                            }

                                                        </div>
                                                        <div className="pagination_inner__box remove-bg" style={ { display: this.state.credData.length > this.state.count ? '' : 'none' } }>
                                                            <div className="Page_navigation">
                                                                <ul className="pagination_ul">
                                                                    <li className={ this.state.indexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                        <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page" onClick={ (event) => { this.handlePreviousClick(event); } }>
                                                                            <ReactTooltip id="prev-page" place="top" effect="solid">Previous</ReactTooltip>
                                                                            <span aria-hidden="true">«</span>
                                                                            <span className="sr-only">Previous</span>
                                                                        </a>
                                                                    </li>
                                                                    <li className="page-item">
                                                                        <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                            { this.state.indexCount + 1 } - { (this.state.indexCount + this.state.count) > this.state.credData.length ? this.state.credData.length : (this.state.indexCount + this.state.count) }
                                                                        </a>
                                                                    </li>
                                                                    <li className={ this.state.indexCount + this.state.count > this.state.credData.length - 1 ? "page-item disabled" : "page-item" }>
                                                                        <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page" onClick={ (event) => { this.handleNextClick(event); } }>
                                                                            <ReactTooltip id="next-page" place="top" effect="solid">Next</ReactTooltip>
                                                                            <span aria-hidden="true">»</span>
                                                                            <span className="sr-only">Next</span>
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="appCredential_createMsg" style={ { display: this.state.showSuccessPopup ? "" : "none" } }>
                                                    <div className="close_icon" data-tip data-for='closeSuccess' onClick={ () => this.closeAppCred("closeSuccessPopup") }></div>
                                                    <ReactTooltip id="closeSuccess" place='top' effect='solid'>Close</ReactTooltip>
                                                    <p>A new application credential has been created. It will only appear here once. Copy and save the details for further use.</p>

                                                    <ul>
                                                        <li>
                                                            <strong>Name</strong>
                                                            <span >{ this.state.currentEmail }
                                                                <a href="#" onClick={ (e) => { e.preventDefault(); this.copyToclipboard(e, this.state.currentEmail); } } className="copy_icon" data-tip data-for="nameCopy" onMouseLeave={ () => { this.setState({ isCopied: false }); } }>
                                                                    <svg viewBox="0 0 22 25" enableBackground='new 0 0 22 25' xmlSpace="preserve">
                                                                        <g>
                                                                            <path className="cpy12" d="M18.5,22.5h-12c-0.6,0-1-0.4-1-1V6.4c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1v15.1C19.5,22.1,19.1,22.5,18.5,22.5   z"></path>
                                                                            <path className="cpy11" d="M2.5,18.2V3.5c0-0.6,0.4-1,1-1h12.9"></path>
                                                                        </g>
                                                                    </svg>
                                                                </a>
                                                                <ReactTooltip id="nameCopy" place='top' effect='solid'>{ this.state.isCopied ? "Copied" : "Copy" }</ReactTooltip>
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <strong>ID</strong>
                                                            <span>{ this.state.currentId }
                                                                <a href="#" onClick={ (e) => { e.preventDefault(); this.copyToclipboard(e, this.state.currentId); } } className="copy_icon" data-tip data-for="idCopypopup" onMouseLeave={ () => { this.setState({ isCopied: false }); } }>
                                                                    <svg viewBox="0 0 22 25" enableBackground='new 0 0 22 25' xmlSpace="preserve">
                                                                        <g>
                                                                            <path className="cpy12" d="M18.5,22.5h-12c-0.6,0-1-0.4-1-1V6.4c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1v15.1C19.5,22.1,19.1,22.5,18.5,22.5   z"></path>
                                                                            <path className="cpy11" d="M2.5,18.2V3.5c0-0.6,0.4-1,1-1h12.9"></path>
                                                                        </g>
                                                                    </svg>
                                                                </a>
                                                                <ReactTooltip id="idCopypopup" place='top' effect='solid'>{ this.state.isCopied ? "Copied" : "Copy" }</ReactTooltip>
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <strong>Secret Key</strong>
                                                            <span>{ this.state.currentSecret }
                                                                <a href="#" onClick={ (e) => { e.preventDefault(); this.copyToclipboard(e, this.state.currentSecret); } } className="copy_icon" data-tip data-for="descCopy" onMouseLeave={ () => { this.setState({ isCopied: false }); } }>
                                                                    <svg viewBox="0 0 22 25" enableBackground='new 0 0 22 25' xmlSpace="preserve">
                                                                        <g>
                                                                            <path className="cpy12" d="M18.5,22.5h-12c-0.6,0-1-0.4-1-1V6.4c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1v15.1C19.5,22.1,19.1,22.5,18.5,22.5   z"></path>
                                                                            <path className="cpy11" d="M2.5,18.2V3.5c0-0.6,0.4-1,1-1h12.9"></path>
                                                                        </g>
                                                                    </svg>
                                                                </a>
                                                                <ReactTooltip id="descCopy" place='top' effect='solid'>{ this.state.isCopied ? "Copied" : "Copy" }</ReactTooltip>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <p className='note_txt'><strong>Note:</strong> By default, the region is set to <b>LA3</b>. <a href='https://docs.idrivecompute.com/hc/en-us/articles/7001518977949-Region' target="_blank">Refer this guide to replace the default region with the desired region.</a></p>
                                                    <button className="common_cta_btn blue dwnld-openrc" onClick={ (e) => this.downLoadData(e, "sh") }>Download openrc file</button>
                                                    <button className="common_cta_btn blue dwnld-cloud" onClick={ (e) => this.downLoadData(e, "yaml") }>Download yaml file</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div className={ this.state.openAppCred ? "main_slider createCredential active" : "main_slider createCredential" }>
                                <div className="slider_bg_shadow"></div>
                                <div className="slider_wrapper">
                                    <div className="main_slider_container">
                                        <div className="close_icon" data-tip data-for='closeCred' onClick={ (e) => this.closeAppCred("appSlider") }></div>
                                        <ReactTooltip id='closeCred' place='left' effect='solid'>Close</ReactTooltip>
                                        <div className="createCredential_slide_wrap">
                                            <div className="head_block">
                                                <h2>
                                                    <span className="icon_img">
                                                        <span className="svg_wrap">
                                                            <svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" d="M448.8,287.9H288.5v160.3c0,17.7-14.4,32.1-32.1,32.1l0,0  c-17.7,0-32.1-14.4-32.1-32.1V287.9H64.1c-17.7,0-32.1-14.4-32.1-32.1s14.4-32.1,32.1-32.1h160.3V63.5c0-17.7,14.4-32.1,32.1-32.1  l0,0c17.7,0,32.1,14.4,32.1,32.1v160.3h160.3c17.7,0,32.1,14.4,32.1,32.1S466.5,287.9,448.8,287.9z"></path>
                                                            </svg>
                                                        </span>
                                                    </span>Create a new application credential
                                                </h2>
                                            </div>
                                            <div className="createCredential_content_wrap">
                                                <div className="common_txtBox_row">
                                                    <label>Name</label>
                                                    <input ref={ this.credNameRef } maxLength={ 20 } value={ this.state.credName } type="text" name="credName" className="txt_box" placeholder="Provide a name" onChange={ (e) => this.handleCredFields(e) } />
                                                    { this.state.credNameError ? <span className="err_msg" style={ { color: "red" } } >{ this.state.credNameError }</span> : null }
                                                </div>
                                                <div className="common_txtBox_row checkBoxrow">
                                                    <label className="checkBox">
                                                        <input type="checkbox" name="expire" id="never_expired" checked={ this.state.isNeverExpire } onClick={ () => {
                                                            this.setState({
                                                                isNeverExpire: !this.state.isNeverExpire,
                                                                expirationDate: "",
                                                                expirationTime: ""
                                                            });
                                                        } } />
                                                        <span className="checkmark"></span>
                                                        <p className="add_on_head">Never expires</p>
                                                    </label>
                                                    <span className="question_icon svg_wrap" data-tip data-for="expire_tool_tip" >
                                                        <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                            <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                        </svg>
                                                    </span>
                                                    <ReactTooltip id="expire_tool_tip" place='right' effect='solid'>
                                                        On selecting this option,<br></br> the application credential will never expire<br></br> and you can avoid regular password changes
                                                    </ReactTooltip>
                                                </div>
                                                <div className='expiryDatetime-blk' style={ { display: this.state.isNeverExpire ? "none" : "" } }>
                                                    <div className="common_txtBox_row ">
                                                        <label>Expiration Date</label>
                                                        <div className="input_text_wrap">
                                                            <DatePicker
                                                                selected={ this.state.expirationDate }
                                                                onChange={ (date) => this.setState({
                                                                    expirationDate: date,
                                                                    credDateError: ""
                                                                }) }
                                                                minDate={ new Date() }
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                className="input_date"
                                                                popperPlacement="bottom-start"
                                                                dateFormat="MMMM d, yyyy"
                                                            />
                                                            <span className="icon"></span>

                                                        </div>
                                                        { this.state.credDateError ? <span className="err_msg" style={ { color: "red" } } >{ this.state.credDateError }</span> : null }
                                                    </div>
                                                    <div className="common_txtBox_row expireTime" >
                                                        <label>Expiration Time</label>
                                                        <div className="input_text_wrap" style={ { position: 'relative' } }>
                                                            <DatePicker
                                                                selected={ this.state.expirationTime }
                                                                onChange={ (time) => this.setState({
                                                                    expirationTime: time,
                                                                    credTimeError: ""
                                                                }) }
                                                                showTimeSelect
                                                                showTimeSelectOnly
                                                                timeIntervals={ 10 }
                                                                timeCaption="Time"
                                                                dateFormat="hh:mm aa"
                                                                className="input_time"
                                                                popperPlacement="bottom-end"

                                                            />
                                                            <span className="icon"></span>
                                                        </div>
                                                        { this.state.credTimeError ? <span className="err_msg" style={ { color: "red" } } >{ this.state.credTimeError }</span> : null }
                                                    </div>
                                                </div>

                                                <div className="common_txtBox_row">
                                                    <label>Description</label>
                                                    <textarea ref={ this.credDescRef } value={ this.state.credDesc } name="credDesc" className="txt_box" maxLength={ 100 } onChange={ (e) => this.handleCredFields(e) }></textarea>
                                                    { this.state.credDescError ? <span className="err_msg" style={ { color: "red" } } >{ this.state.credDescError }</span> : null }
                                                </div>
                                                <div className="cta_wrap">
                                                    <input type="button" name="" value="Create Application Credential" className="common_cta_btn blue createCredBtn"
                                                        onClick={ (e) => this.createAppCred(e) }
                                                    />
                                                    <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ (e) => this.closeAppCred("appSlider") } />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    {/** delete popup for app creds */ }
                    <div className={ this.state.deleteAppCred ? "main_popup delete_appcred_popup active" : "main_popup delete_appcred_popup" }>
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap"> <span className="close_icon" data-tip data-for="closeDeleteCred" onClick={ () => { this.setState({ deleteAppCred: false }); $("body").removeClass("popup_no_scroll"); } }></span>
                                    <ReactTooltip id='closeDeleteCred' place='left' effect='solid'>Close</ReactTooltip>

                                    <div className="popup_header">
                                        <div className="sub_title">Delete Application Credential</div>
                                    </div>
                                    <div className="popup_body">
                                        <p>Are you sure you want to delete this application credential?</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <div className="btn btn_confirm" onClick={ () => this.deleteUserAppCred() }>Delete</div>
                                            <div className="btn btn_cancel" onClick={ () => { this.setState({ deleteAppCred: false }); $("body").removeClass("popup_no_scroll"); } }>Cancel</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/** START TwoFA Popup */ }
                    <div className={ this.state.is2fapopup ? "main_popup enable2fa_popup active" : "main_popup enable2fa_popup" }>
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.setState({ is2fapopup: false }) }></span>
                                    <div className="popup_header">
                                        { this.state.adminStatus === "ENABLED" ?
                                            <div className="sub_title">Disable Two-factor authentication for Users</div>
                                            : <div className="sub_title">Enable Two-factor authentication for Users</div>
                                        }

                                    </div>
                                    <div className="popup_body">
                                        { this.state.adminStatus === "ENABLED" ?
                                            <p>Do you want to disable Two-factor Authentication for your account?</p> :
                                            <p>All sign in to users' account will be authenticated by using a one-time verification code sent to their registered email address or phone number or generated via Time-based OTP Authenticator app. Once enabled, all users must configure two-factor authentication in order to sign in.</p>
                                        }
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns button_inverse">
                                            <button className="btn btn_cancel" onClick={ () => this.setState({ is2fapopup: false }) }>Cancel</button>
                                            <button id="enablefocus" className="btn blue" onClick={ () => this.enable2fa() }>{ this.state.adminStatus === "ENABLED" ? "Disable" : "Enable" }</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/** END TwoFA Popup */ }

                    {/** START Unlink slack channel popup */ }
                    <div className={ this.state.isUnlinkSlackPopupActive ? "main_popup enable2fa_popup active" : "main_popup enable2fa_popup" }>
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.setState({ isUnlinkSlackPopupActive: false }) }></span>
                                    <div className="popup_header">
                                        <div className="sub_title">Unlink Slack Integration</div>
                                    </div>
                                    <div className="popup_body">
                                        <p>
                                            Slack channel <strong>{ (() => {
                                                let dWebhook = this.state.slackWebhooks[this.state.unlinkSlackChannelIdx]?.data;
                                                return (
                                                    dWebhook?.channelName + ", " + dWebhook?.teamName
                                                );
                                            })() }</strong> associated with event based notifications. Unlinking would dissociate the slack integration and delete it from your account.
                                        </p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns button_inverse">
                                            <button className="btn btn_cancel" onClick={ () => this.setState({ isUnlinkSlackPopupActive: false }) }>Cancel</button>
                                            <button id="enablefocus" className="btn blue" onClick={ (event) => this.deleteWebhook(event, this.state.unlinkSlackChannelIdx) }>
                                                Unlink
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/** END Unlink slack channel popup */ }

                    {/** START Add recipients slider */ }
                    <div className={ this.state.showAddRecipients ? "main_slider addRecipientsSlider active" : "main_slider addRecipientsSlider" }>
                        <div className="slider_bg_shadow"></div>
                        <div className="slider_wrapper" id="addRecipientsSlider">
                            <div className="main_slider_container">
                                <div className="close_icon" onClick={ event => this.toggleAddRecipientsSlider(event) } data-tip data-for={ "closeAddRecipientsSlider" } data-toggle data-placement="top"></div>
                                <ReactTooltip id='closeAddRecipientsSlider' place='top' effect='solid'>Close</ReactTooltip>
                                <div className="addRecipientsSlider_wrap">
                                    <div className="head_block">
                                        <h2>
                                            <span className="svg_wrap">
                                                <svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground={ "0 0 19.6 16.5" } xmlSpace="preserve">
                                                    <path fillRule='evenodd' clipRule={ "evenodd" } fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                                </svg>
                                            </span>
                                            Edit alert recipients
                                        </h2>
                                    </div>
                                    <div className="addRecipients_content_wrap">
                                        <p>
                                            Select the user(s) you wish to be notified
                                            <span className="selItems">{ this.state.sliderEmailList.filter(data => data.isSelected).length } of { this.state.users.length } Selected</span>
                                        </p>
                                        <div className="srchReceipantsBlk">
                                            <div className="search_btn">
                                                <svg className="header_search" viewBox="0 0 26 26">
                                                    <path className="cls-1" d="M11.33,5a6.33,6.33,0,1,0,6.34,6.32A6.32,6.32,0,0,0,11.33,5Zm0,10.84a4.52,4.52,0,1,1,4.52-4.52A4.52,4.52,0,0,1,11.33,15.85Z"></path>
                                                    <path className="cls-1" d="M14.3,15.58l1.28-1.28L21,19.72,19.73,21Z"></path>
                                                </svg>
                                            </div>
                                            <input type="text" ref={ this.addRecipientsSliderSearchFocus } id="addRecipientsSliderSearch" placeholder="Search" className="srchReceipants" onChange={ event => this.addRecipientsSliderSearchHandler(event) } value={ this.state.addRecipientsSliderSearchText } />
                                            <span className="clear_srch" data-tip data-for="clearAddRecipientsSearch" data-toggle data-placement="top" style={ { display: String(this.state.addRecipientsSliderSearchText).length === 0 ? "none" : "block" } } onClick={ event => this.clearAddRecipientsSearch(event) } />
                                        </div>
                                        <ReactTooltip id='clearAddRecipientsSearch' place='top' effect='solid'>Clear</ReactTooltip>
                                        <div className="tabular_data_wrap">
                                            <div className={ this.isPartiallySelected() ? "table_header semiactive" : "table_header" }>
                                                <ul>
                                                    <li className="th">
                                                        <div className="col col1">
                                                            <label className="checkBox applyToall">
                                                                <input type="checkbox" id="sliderEmailMultiSelect" onChange={ event => this.sliderEmailMultiSelectHandler(event) } checked={ this.state.sliderEmailSelectAll } />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                        <div className="col col2" onClick={ (event) => { this.sortClickHandler(event); this.addRecipientsEmailSort(event); } } tabIndex={ 0 } onKeyDown={ event => { if(event.key == " ") { this.sortClickHandler(event); this.addRecipientsEmailSort(event); } } }>
                                                            Users
                                                            <span className="sort_icon"></span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div id="addRecipientsTableData" className="table_data" onMouseEnter={ event => this.scrollBarFocusHandler(event) } onMouseLeave={ event => this.scrollBarFocusHandler(event) } style={ { maxHeight: "inherit", overflowY: "inherit" } }>
                                                <ScrollArea ref={ this.scrollRef }
                                                    speed={ 0.8 }
                                                    style={ { maxHeight: this.state.addRecipientsSliderMaxHeight } }
                                                    vertical={ true }
                                                    horizontal={ false }
                                                    minScrollSize={ 10 }
                                                    smoothScrolling={ true }
                                                    verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: this.state.scrollBarOpacity, transition: 'ease-in-out 50ms' } }
                                                    verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: this.state.scrollBarOpacity, transition: 'ease-in-out 50ms' } }
                                                    stopScrollPropagation={ true }
                                                >
                                                    <ul>
                                                        {
                                                            this.state.sliderEmailList.map((data, i) => {
                                                                return <li className="tr" key={ i } style={ { display: (String(this.state.addRecipientsSliderSearchText).length < 1 || String(data.email).startsWith(this.state.addRecipientsSliderSearchText)) ? "block" : "none", cursor: "pointer" } } onClick={ event => this.userEmailSelectHandler(event, i) } tabIndex={ 0 }>
                                                                    <div className="col col1">
                                                                        <label className="checkBox">
                                                                            <input type="checkbox" onChange={ () => { } } checked={ data.isSelected } tabIndex={ -1 } />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="col col2">
                                                                        <span data-tip={ data.email } id={ "addRecipientsUserEmail_" + i } data-for={ "addRecipientsUserEmailTooltip_" + i } data-toggle="tooltip">
                                                                            { data.email }
                                                                        </span>
                                                                    </div>
                                                                    <ReactTooltip place='top' effect='solid' id={ 'addRecipientsUserEmailTooltip_' + i } disable={ this.shouldDisableEmailTooltip(i) }>
                                                                        { data.email }
                                                                    </ReactTooltip>
                                                                </li>;
                                                            })
                                                        }
                                                        {
                                                            this.state.sliderEmailList.filter((data, i) => String(data.email).startsWith(this.state.addRecipientsSliderSearchText)).length === 0 ?
                                                                (
                                                                    <li className="tr table_data_empty">
                                                                        <div className="outer_empty_wrap">
                                                                            <div className="inner_empty_wrap">
                                                                                <div className="svg_wrap empty_icon search_empty"></div>
                                                                                <p className="empty_title">No results found matching your search</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                ) :
                                                                ""
                                                        }
                                                    </ul>
                                                </ScrollArea>
                                            </div>
                                        </div>
                                        <div className="default_slectBlk">
                                            <label className="checkBox">
                                                <input type="checkbox" name="defaultEmailSelectionAlertPolicy" checked={ this.state.defaultEmailSelection } onChange={ event => this.defaultEmailSelectionHandler(event) } />
                                                <span className="checkmark"></span>
                                                <p className="add_on_head">Make this my default selection for future alert policies</p>
                                            </label>
                                        </div>
                                        <div className="cta_wrap">
                                            <input type="button" value="Save Recipients for Alert Policy" className="common_cta_btn blue" onClick={ event => this.addRecipientsSubmitHandler(event) } />
                                        </div>
                                        <p style={ { display: "none" } }><b>Note:</b> Standard charges will apply.<a target="_blank" rel="noopener noreferrer" href="https://www.idrivecompute.com/faq_plans.htm#additional-charges"> Know More</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/** END Add recipients slider */ }

                </div >
                <CommonMessage message={ this.state.message } msgType={ this.state.msgType } isUserSubscribed={ this.state.isUserSubscribed }
                    handler={
                        () => {
                            if(this.state.message !== '') {
                                this.setState({ message: '' });
                            }
                        }
                    }
                />
            </div >
        );
    }
}
function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}
export default withStyles(styles)(SettingsMain);
